module.exports = "/images/shopify.png?7c87093f5c8dc43e43d5f3c0a0251e5f";